import * as Connector from 'shared/connectors/settlementConnector';
import { SETTLEMENTS } from 'store/types';

const init = () => ({
  type: SETTLEMENTS.GET_SETTLEMENTS_INIT,
});

export const success = settlements => ({
  type: SETTLEMENTS.GET_SETTLEMENTS_SUCCESS,
  payload: {
    settlements,
  },
});

const failure = () => ({
  type: SETTLEMENTS.GET_SETTLEMENTS_FAILURE,
});

const getSettlements = () => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getSettlements();
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getSettlements;
